import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'

export class FutManagerAxiosClass {
  /** Current dashboard features (`VITE_API_URL`). */
  axiosInstance: AxiosInstance | undefined

  /** New features / admin panel (`VITE_ADMIN_API_URL`). */
  adminAxiosInstance: AxiosInstance | undefined

  installAxios(config: AxiosRequestConfig, accept?: string) {
    this.axiosInstance = axios.create(config)
    this.axiosInstance.defaults.headers.common.Accept = accept ?? 'application/json'
  }

  installAdminAxios(config: AxiosRequestConfig, accept?: string) {
    this.adminAxiosInstance = axios.create(config)
    this.adminAxiosInstance.defaults.headers.common.Accept = accept ?? 'application/json'
  }
}
